import Link from 'next/link'
import React from 'react'
import Image from 'next/image'
import {cn} from '@heroui/react'

import Box from '../UI/Box/Box'

const GooglePlayButton = ({className}: {className?: string}) => {
  return (
    <Link
      className="w-fit h-fit rounded-md overflow-hidden"
      href="https://play.google.com/store/apps/details?id=com.advicemy.advicemy">
      <Box className={cn('relative h-12 w-[182px]', className)}>
        <Image alt="advicemyGooglePlay" fill src="/google-play.png" />
      </Box>
    </Link>
  )
}

export default GooglePlayButton
